/*
 * Curve editor column header (W2-04b curve-editor). Design tokens only (src/ui/styles/tokens.css). Two rows fit the
 * host's 52 px header slot; long titles and summaries truncate with an ellipsis. Layer states are shown by icon and
 * text, never by colour alone.
 */

.header {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 0;
  overflow: hidden;
  background: var(--color-surface-1);
  color: var(--color-text);
  font-size: var(--text-xs);
}

/* One line per row (UX-039): a row that does not fit truncates its text instead of wrapping over the next row. */
.header > [role='toolbar'] {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: var(--space-1);
  min-width: 0;
  height: 26px;
  padding: 0 var(--space-1);
  overflow: hidden;
}

.header > [role='toolbar'] > * {
  flex-shrink: 0;
}

.header > [role='toolbar'] > .title,
.header > [role='toolbar'] > .summary,
.header > [role='toolbar'] > .spacer {
  flex-shrink: 1;
}

.title {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  /* Enough for "Position X" before it truncates (the full title is the tooltip). */
  min-width: 88px;
  flex: 0 1 auto;
  font-weight: var(--weight-semibold);
  color: var(--color-text);
}

.titleText {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.chips {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  flex: 0 0 auto;
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  height: var(--control-h-sm);
  max-width: 100%;
  padding: 0 var(--space-2);
  border: var(--border-width) solid var(--color-border);
  border-radius: var(--radius-pill);
  background: var(--color-surface-2);
  color: var(--color-text-muted);
  font: inherit;
  cursor: pointer;
  white-space: nowrap;
}

.chip:hover {
  background: var(--color-surface-hover);
  color: var(--color-text);
}

.chip[aria-pressed='true'] {
  border-color: var(--color-accent-border);
  background: var(--color-accent-muted);
  color: var(--color-text);
  font-weight: var(--weight-semibold);
}

.chip:focus-visible {
  outline: var(--focus-ring-width) solid var(--color-focus-ring);
  outline-offset: var(--focus-ring-offset);
}

.spacer {
  flex: 1 1 auto;
  min-width: 0;
}

.summary {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: var(--color-text-muted);
}

.channelRow {
  position: relative;
  height: 26px;
  min-width: 0;
}

.lane {
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  gap: var(--space-1);
  padding: 0 var(--space-1);
  overflow: hidden;
  border-right: var(--border-width) solid var(--color-divider);
  color: var(--color-text-muted);
}

.laneText {
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

@media (prefers-reduced-motion: reduce) {
  .chip {
    transition: none;
  }
}
